import DateRangePicker, {
  type onApplyFn,
} from "@/components/ui/date-range-picker";

interface ShareOfVoiceFilterHeaderProps {
  filterDays: number;
  isCustomDaysRange: boolean;
  startDate?: Date;
  endDate?: Date;
  onDateRangeChange: onApplyFn;
}

const ShareOfVoiceFilterHeader = ({
  filterDays,
  isCustomDaysRange,
  startDate,
  endDate,
  onDateRangeChange,
}: ShareOfVoiceFilterHeaderProps) => {
  return (
    <header className="sticky top-0 z-10 bg-white py-9 px-16">
      <div>
        <h1 className="text-xs font-semibold text-gray-900 tracking-wide mb-2">
          Share of Voice Over Time
        </h1>
        <DateRangePicker
          filterDays={filterDays}
          isCustomDaysRange={isCustomDaysRange}
          startDate={startDate}
          endDate={endDate}
          onApply={onDateRangeChange}
        />
      </div>
    </header>
  );
};

export default ShareOfVoiceFilterHeader;
